function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import LoadingAnimation from "../loadinganimation/LoadingAnimation";
const DEFAULT_DELAY = 1000;
const DEFAULT_POST_DELAY = 300;
const K100 = "#f7f8f9";
function alpha(color, num) {
  const value = num * 255;
  const hex = value.toString(16).padStart(2, "0");
  const newColor = color[0] === "#" ? color.substring(1, 7) : color.substring(0, 6);
  return `#${newColor}${hex}`;
}
const LoadingOverlay = ({
  isLoading,
  duration = 300,
  isTableRowLoader
}) => {
  const styles = useSpring({
    background: isLoading ? alpha(K100, 0.8) : alpha(K100, 0),
    opacity: isLoading ? 1 : 0,
    config: {
      duration
    }
  });
  const overlayProps = {
    style: {
      background: styles.background,
      left: isTableRowLoader ? 0 : "inherit"
    },
    className: `tui-loading-overlay ${isLoading ? "is-loading" : ""}`,
    role: "progressbar",
    "aria-busy": isLoading
  };
  const children = /*#__PURE__*/React.createElement(animated.div, {
    style: {
      opacity: styles.opacity
    }
  }, /*#__PURE__*/React.createElement(LoadingAnimation, {
    delay: 0
  }));
  return isTableRowLoader ? /*#__PURE__*/React.createElement(animated.td, overlayProps, children) : /*#__PURE__*/React.createElement(animated.div, overlayProps, children);
};
LoadingOverlay.defaultProps = {
  isTableRowLoader: false,
  duration: 2000
};
export function useDelayedLoading({
  isLoading,
  delay = DEFAULT_DELAY,
  postDelay = DEFAULT_POST_DELAY
}) {
  const [loading, setLoading] = useState(isLoading);
  const timeout = useRef();
  const loadingTimeStamp = useRef();
  useEffect(() => {
    if (timeout.current) clearTimeout(timeout.current);
    const scopeTimeout = window.setTimeout(() => {
      setLoading(isLoading);
      timeout.current = null;
      loadingTimeStamp.current = Date.now();
    }, isLoading ? delay : postDelay);
    timeout.current = scopeTimeout;
    return () => void clearTimeout(scopeTimeout);
  }, [isLoading, delay, postDelay]);
  return loading;
}
const Loader = ({
  isLoading,
  delay,
  postDelay,
  children,
  ...props
}) => {
  const loading = useDelayedLoading({
    isLoading,
    delay,
    postDelay
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    style: {
      position: "relative",
      ...props.style
    }
  }), children, /*#__PURE__*/React.createElement(LoadingOverlay, {
    isLoading: loading
  }));
};
Loader.displayName = "Loader";
Loader.defaultProps = {
  delay: DEFAULT_DELAY,
  postDelay: DEFAULT_POST_DELAY
};
export { Loader, LoadingOverlay };
//# sourceMappingURL=Loader.js.map